import { UrlConstants } from "../url.constants";
export class ApiCommentsConstants {
    // TODO: JP to clean code - Speak to Matthew
    static URL = UrlConstants.API_V2 + "Comment";
    static FUNCTION_SET_SHOW_HIDE_COMMENTS_IN_PORTAL = "SetShowHideCommentsInPortal";
}
